<template>
  <div v-if="isFinish" id="footer">
    <!-- 上 -->
    <el-row class="footer-top">
      <el-col
        class="footer-top-item footer-top-item-center"
        :xs="20"
        :sm="20"
        :md="14"
        :lg="14"
        :xl="14"
      >
        <el-col class="footer-top-item-center-container" :span="24">
          <el-col :span="24">
            <div class="footer-title">我们联系您</div>
            <div
              style="display: flex; justify-content: space-between; margin-bottom: 30px;"
            >
              <el-input
                v-model="form.content"
                size="small"
                class="remark"
                type="textarea"
                autosize
                placeholder="问题备注："
                minlength="250"
                show-word-limit
              />
              <div class="top-input">
                <el-input
                  v-model="form.name"
                  size="small"
                  placeholder="姓名："
                />
                <el-input
                  v-model="form.tel"
                  size="small"
                  placeholder="联系电话："
                />
                <el-button
                  size="small"
                  type="warning"
                  @click="add"
                >提交</el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="footer-title">联系我们</div>
            <div class="footer-content" v-html="setting.information.value" />
          </el-col>
        </el-col>
      </el-col>
      <el-col
        class="footer-top-item footer-top-item-right-img"
        :xs="20"
        :sm="20"
        :md="2"
        :lg="2"
        :xl="2"
      >
        <el-col :xs="8" :sm="8" :md="24" :lg="24" :xl="24">
          <!-- <div class="weChat-qr">
            <el-image
              class="weChat-qr-pic"
              :src="setting.weixin_code.value"
              alt="微信公众号"
            />
          </div>
          <span class="footer-title">微信公众号</span> -->
        </el-col>
        <el-col :xs="8" :sm="8" :md="24" :lg="24" :xl="24">
          <!-- <div class="weChat-qr">
            <el-image
              class="weChat-qr-pic"
              :src="setting.tianmao_code.value"
              alt="天猫旗舰店"
            />
          </div>
          <span class="footer-title">天猫旗舰店</span> -->
        </el-col>
      </el-col>
    </el-row>
    <!-- 下 -->
    <el-row class="footer-bottom">
      <div class="friend-links">
        <span>友情链接：</span>
        <el-link
          v-for="(item, index) in friendLink"
          :key="index"
          class="friend-link"
          :underline="false"
          :href="item.url"
          :target="item.target"
        >{{ item.name }}</el-link>
      </div>
      <div class="record-container">
        <span class="info">Copyright © 2009-{{ nowYear }} All Rights Reserved.</span>
        <span class="info">
          <a :href="setting.miitbeian_url.value">
            <span class="image">
              <img
                v-if="setting.miitbeian_ico.value"
                :src="setting.miitbeian_ico.value"
              > </span>&nbsp;{{ setting.miitbeian.value }}</a>
        </span>
        <span> 深圳市和顺堂医药有限公司万科城分店</span>
        <span v-if="setting.beian_url.value != ''">
          <a :href="setting.beian_url.value">
            <span class="image">
              <img
                v-if="setting.beian_ico.value"
                :src="setting.beian_ico.value"
                alt=""
              > </span>{{ setting.beian.value }}</a>
        </span>
      </div>
    </el-row>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/index'
import API from '@/api/service'

export default {
  name: 'Footer',
  data() {
    return {
      setting: null,
      isFinish: false,
      form: {
        name: '',
        tel: '',
        content: ''
      },
      friendLink: [],
      nowYear: '2020'
    }
  },
  beforeMount() {
    this.nowYear = timeFormat(new Date().getTime(), 'yyyy')
    setTimeout(() => {
      this.setting = this.$getLoc({ key: 'setting', json: 1 })
      this.isFinish = true
      const training = this.setting.information.value.replace(/\n/g, '<br>')
      this.setting.information.value = training
    }, 30)
  },
  mounted() {
    this.getFriendLink()
  },
  methods: {
    getFriendLink() {
      API.getFriendlink().then(res => {
        this.friendLink = res.data
      })
    },
    add() {
      if (!this.form.name) {
        this.$message({
          message: '请输入姓名',
          type: 'warning'
        })
        return false
      } else if (!this.form.tel) {
        this.$message({
          message: '请输入手机号',
          type: 'warning'
        })
        return false
      } else if (!this.form.content) {
        this.$message({
          message: '请输入留言内容',
          type: 'warning'
        })
        return false
      } else {
        API.getAddBorad(this.form).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '留言成功，感谢您的支持！',
              type: 'success'
            })
            this.form = {
              name: '',
              tel: '',
              content: ''
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/footer/xl.scss";
@media screen and (max-width: 1920px) {
  @import "@/assets/css/footer/lg.scss";
}
@media screen and (max-width: 1200px) {
  @import "@/assets/css/footer/md.scss";
}
@media screen and (max-width: 992px) {
  @import "@/assets/css/footer/sm.scss";
}
@media screen and (max-width: 768px) {
  @import "@/assets/css/footer/xs.scss";
}
</style>



// WEBPACK FOOTER //
// src/view/common/footer.vue